import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type Customer } from '../../../../../src/types/Customer';

export type PatchCustomerParams = {
  customer: Partial<Customer> & {
    password?: string;
    password_confirm?: string;
  };
};

export async function patchApiV2CustomersCustomerId(
  params: PatchCustomerParams
) {
  return await send<Customer>({
    path: `/api/v2/customers/self/`,
    method: 'PATCH',
    body: params.customer,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
      'Content-Type': 'application/json',
    }),
  });
}
